<template>
  <iDropdown
    :show-dropdown="isOpen"
    position="right"
    overlay-position="bottom-right"
    width="hug"
    data-testid="quick-fix-menu"
    @close="close"
  >
    <template #trigger>
      <iButton
        variant="tertiary"
        size="small"
        icon-left="add"
        aria-label="New quick fix"
        data-testid="quick-fix-trigger"
        @click="toggle"
      />
    </template>
    <template #overlay>
      <iColumn
        v-if="isOpen"
        :width="panelWidth"
        gap="small"
        data-testid="quick-fix-panel"
      >
        <iText v-if="!rootBooted" variant="subtle" data-testid="quick-fix-booting">
          loading…
        </iText>
        <AppComponent
          v-else
          component-name="QuickFixPanelComponent"
          app-name="Q3po"
          :contexts="panelContexts"
        />
        <iText v-if="rootBooted && creationRejection" variant="error" data-testid="quick-fix-error">
          {{ creationRejection }}
        </iText>
      </iColumn>
    </template>
  </iDropdown>
</template>

<script>
import App from "@bloglovin/inspire-engine/App";
import AppComponent from "@bloglovin/inspire-engine/Components/AppComponent";
import { PROJECT_MANAGEMENT_APP, createProjectRejection, quickFixPanelContexts, waitForRootBoot } from "@/helpers/quick-fix.mjs";

const PANEL_WIDTH = 480;

export default {
  name: "QuickFixMenu",
  components: { AppComponent },
  data() {
    return {
      isOpen: false,
      panelWidth: PANEL_WIDTH,
      rootBooted: App.isRootBooted(),
    };
  },
  computed: {
    panelContexts() {
      return quickFixPanelContexts(App.getRoot().getDependencyConfigurationId(PROJECT_MANAGEMENT_APP));
    },
    creationRejection() {
      return createProjectRejection(App.getRoot().getSyncRejection());
    },
  },
  mounted() {
    window.addEventListener("inspire:navigate", this.close);
    if (!this.rootBooted) {
      waitForRootBoot(() => App.isRootBooted()).then(() => {
        this.rootBooted = true;
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener("inspire:navigate", this.close);
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    close() {
      this.isOpen = false;
    },
  },
};
</script>
